import { useState } from 'react';
import BackgroundFlow from './components/layout/BackgroundFlow';
import Topbar from './components/layout/Topbar';
import Menu from './components/layout/Menu';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero/Hero';
import Work from './components/sections/Work/Work';
import About from './components/sections/About/About';
import Contact from './components/sections/Contact/Contact';

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="app">
      <BackgroundFlow />
      <Topbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <main>
        <Hero />
        <Work />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
